import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from './base';

export const TrackerHistoryEntrySchema = z.object({
  timestamp: DateSchema.optional(),
  battery: z.number().optional(),
  mcc: z.number().optional(),
  mnc: z.number().optional(),
  cellId: z.number().optional(),
  lac: z.number().optional(),
  radio: z.enum(['GSM', 'UMTS', 'CDMA', 'LTE', 'NR']).optional(),
});
export const TrackerHistoryEntriesSchema = z.array(TrackerHistoryEntrySchema);

export type TrackerHistoryEntry = z.infer<typeof TrackerHistoryEntrySchema>;
export type TrackerHistoryEntries = z.infer<typeof TrackerHistoryEntriesSchema>;

export const TrackerHistoryEntryPrototypeSchema = z
  .object({
    trackerId: ObjectIdSchema,
    timestamp: DateSchema,
    battery: z.number().optional(),
    mcc: z.number().optional(),
    mnc: z.number().optional(),
    cellId: z.number().optional(),
    lac: z.number().optional(),
    radio: z.enum(['GSM', 'UMTS', 'CDMA', 'LTE', 'NR']).optional(),
  })
  .transform((data) => ({
    trackerId: data.trackerId,
    timestamp: data.timestamp,
    battery: data.battery,
    mcc: data.mcc,
    net: data.mnc, // Rename mnc to net
    cell: data.cellId, // Rename cellId to cell
    area: data.lac, // Rename lac to area
    radio: data.radio,
  }));

export type TrackerHistoryEntryPrototype = z.infer<typeof TrackerHistoryEntryPrototypeSchema>;
